import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Link2Shape",
  "use": "svg-icon-Link2Shape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Link2Shape\"><path d=\"M11.586 3H10a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V4.414L8.707 8.707a1 1 0 0 1-1.414-1.414zm.58 6.583a.917.917 0 1 1 1.834 0v2.667A2.75 2.75 0 0 1 11.25 15h-7.5A2.75 2.75 0 0 1 1 12.25v-7.5A2.75 2.75 0 0 1 3.75 2h2.667a.917.917 0 0 1 0 1.833H3.75a.917.917 0 0 0-.917.917v7.5c0 .506.41.917.917.917h7.5c.506 0 .917-.41.917-.917V9.583z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol